module.exports = __webpack_public_path__ + "img/20180815_151844_196.3eb525a0.jpg";